export const apiMapper = {
  alarm: {
    tableKey: 'isAlarm',
  },
  autopilot_read: { // todo
    tableKey: 'autoPilot',
  },
  working_percentage: {
    tableKey: 'working',
  },
  room_temperature: {
    tableKey: 'avgTemp',
  },
  relative_humidity: {
    tableKey: 'avgRH',
  },
  temperature_setpoint_read: {
    tableKey: 'setTemp',
  },
  return_temperature: {
    tableKey: 'returnTemp',
  },
  power: {
    tableKey: 'power',
    consumptionKey: 'powerUsage',
  },
  today_energy: {
    tableKey: 'consumption',
    consumptionKey: 'consumption',
  },
  runtime: {
    tableKey: 'hours',
  },
  mode_read: {
    tableKey: 'mode',
    // Removed hardcoded mappings to use enum mappings from backend API
  },
  operation_mode_read: {
    tableKey: 'opMode',
    0: 'local',
    1: 'remote',
    'Local': 'local',
    'Remote': 'remote',
    'local': 'local',
    'remote': 'remote'
  },
  status_read: {
    tableKey: 'status',
    0: 'off',
    1: 'on',
    'Off': 'off',
    'On': 'on',
    'False': 'off',
    'True': 'on',
  },
  fan_mode_read: {
    tableKey: 'fanSpeed',
    // Removed hardcoded mappings to use enum mappings from backend API
  },
  avg_working_percentage: {
    operationKey: 'averageWorking',
  },
  today_avg_working_percentage: {
    operationKey: 'avgToday',
  },
  today_avg_power: {
    consumptionKey: 'avgToday'
  },
  alarm_code: {
    tableKey: 'alarmCode',
    1: "error1",
    2: "error2",
    3: "error3",
  },
  total_energy_saving: {
    autopilotKey: 'savedPower',
  },
  total_energy_consumption: {
    autopilotKey: 'consumption',
  },
  solar_surplus_rate: {
    solarKey: 'ratio',
  },
  solar_surplus: {
    solarKey: 'solarSurplus',
  },
  irradiance: {
    solarKey: 'irradiance',
  },
  occupancy_current: {
    cameraKey: 'current',
  },
  today_in_count: {
    cameraKey: 'peopleIn',
  },
  today_out_count: {
    cameraKey: 'peopleOut',
  },
  in_count_daily: {
    cameraKey: 'peopleIn',
  },
  out_count_daily: {
    cameraKey: 'peopleOut',
  },
  online_status: {
    tableKey: 'isOnline',
    0: false,
    1: true,
  },
}